import classNames from 'classnames';
import { useTranslateForm } from 'hooks/use-translate-payoff';
import { CurrencyListFieldMetadata } from 'models/forms/fields';
import { useMemo } from 'react';
import { ErrorWrapper } from 'routes/essential-workspace/components/form/error-wrapper';

import './style.scss';
import { useCurrencyPicker } from 'routes/essential-workspace/components/form/fields/currency/use-currency';
import { useFormErrors } from 'routes/essential-workspace/components/form/use-form-errors';
import { useFormFieldData } from 'routes/essential-workspace/components/form/use-form-field-data';

export function CurrencyField({ translationKey, id, availableItems, isReadOnly }: CurrencyListFieldMetadata) {
  const { translateLabel } = useTranslateForm();
  const label = translateLabel(translationKey ?? id);

  const [currency, setCurrency] = useFormFieldData<string>(id);

  const { getFieldError } = useFormErrors();
  const fieldError = getFieldError(id);

  const { currencyRef } = useCurrencyPicker({ currency, setCurrency });

  const availableCcy = useMemo(() => availableItems?.map(item => item.value).join(',') || [], [availableItems]);

  return (
    <ErrorWrapper error={fieldError}>
      <div
        className={classNames('input-group bg-lvl1', {
          'border-bottom border-warning': fieldError?.severity === 'Error',
          'border-bottom border-info': fieldError?.severity === 'Warning',
        })}
      >
        <div className="input-icon-start w-auto px-12px" style={{ height: '40px' }}>
          <label htmlFor={id} className="text-secondary">
            {label}
          </label>
        </div>

        <div className="w-100">
          <sg-currency-picker
            ref={currencyRef}
            classes="currency-essential-input"
            available-ccy={availableCcy}
            show-clear-button={0}
            placeholder={label}
            max-displayed-items={0}
            readonly={isReadOnly}
            inputId={id}
          />
        </div>
      </div>
    </ErrorWrapper>
  );
}
